<template>
    <div class="vx-row pt-5 px-5">
      <div class="vx-col w-full px-8">
        <form method="POST" @submit.prevent="save_changes">
         
                  <div class=" vx-row mt-4">
                    <div class="vx-col mb-8">
                      <label class="vs-input--label">About</label>
                      <vs-switch color="success" class="ml-1 mt-2" v-model="form.is_about" :disabled="!isEditable"> </vs-switch>
                    </div>
                    <div class="vx-col mb-8">
                      <label class="vs-input--label">Update</label>
                      <vs-switch color="success" class="ml-1 mt-2" v-model="form.is_updates" :disabled="!isEditable"> </vs-switch>
                    </div>
                    <div class="vx-col mb-8">
                      <label class="vs-input--label">Member</label>
                      <vs-switch color="success" class="ml-1 mt-2" v-model="form.is_members" :disabled="!isEditable"> </vs-switch>
                    </div>
                    <div class="vx-col mb-8">
                      <label class="vs-input--label">Donation</label>
                      <vs-switch color="success" class="ml-1 mt-2" v-model="form.is_donate" :disabled="!isEditable"> </vs-switch>
                    </div>
                    <div class="vx-col mb-8">
                      <label class="vs-input--label">Contact Us</label>
                      <vs-switch color="success" class="ml-1 mt-2" v-model="form.is_contact_us" :disabled="!isEditable"> </vs-switch>
                    </div>
                    <div class="vx-col mb-8">
                      <label class="vs-input--label">Thumbnail Manage</label>
                      <vs-switch color="success" class="ml-1 mt-2" v-model="form.is_live" :disabled="!isEditable"> </vs-switch>
                    </div>
                     
                    <div class="vx-col mb-8">
                      <label class="vs-input--label">Service List</label>
                      <vs-switch color="success" class="ml-1 mt-2" v-model="form.is_service_booking" :disabled="!isEditable"> </vs-switch>
                    </div>
     
                    <div class="vx-col mb-8">
                      <label class="vs-input--label">FAQ</label>
                      <vs-switch color="success" class="ml-1 mt-2" v-model="form.is_faq" :disabled="!isEditable"> </vs-switch>
                    </div>
             
                  </div>
  
          <!-- Save & Reset Button -->
          <div class="vx-row pt-5 px-5 text-center">
            <div class="vx-col w-full">
              <div class="items-center">
                <vs-button class="mr-2 vs-con-loading__container" id="create-creator" @click="save_changes"> {{ $route.params.id ? 'Update' : 'Add' }}</vs-button>
                <!-- <vs-button color="danger" class="text-left" @click="navigateList">Cancel</vs-button> -->
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
 
  </template>
<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { mapActions, mapState } from 'vuex'
export default {
  /** Page Name */
  name: 'Tab-Management',
  
  /** components */
  components: {
    Cropper
  },
  
  /** data */
  data() {
    return {
      contentType: null,
      cropperRatio: null,
      form: {
        organization: null,
        is_about: false,
        is_donate: false,
        is_updates: false,
        is_members: false,
        is_service_booking: false,
        is_contact_us: false,
        is_faq: false,
        is_live:false
      },
     
      isEditable: true
    }
  },
  created() {
    this.form.organization = this.$route && this.$route.params ? this.$route.params.id : null
    this.fetchTabDetails()
  },
  methods: {
    async fetchTabDetails() {
      if (!this.form.organization) return
      try {
        const res = await this.$http.get(`admin/organization-tab/details/${this.form.organization}`)
        const d = res && res.data && res.data.data ? res.data.data : null
        if (d) {
          this.form = {
            organization: d.organization,
            is_about: !!d.is_about,
            is_donate: !!d.is_donate,
            is_updates: !!d.is_updates,
            is_members: !!d.is_members,
            is_service_booking: !!d.is_service_booking,
            is_contact_us: !!d.is_contact_us,
            is_live:!!d.is_live,
            is_faq: !!d.is_faq
          }
        }
      } catch (e) {
        const message = (e && e.message) || 'Failed to load tab settings'
        this.$vs.notify({ title: 'Error', text: message, color: 'danger', position: 'top-center', time: 4000 })
      }
    },
    async save_changes() {
      if (!this.form.organization) return
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Confirm Changes',
        text: 'Are you sure you want to apply these changes?',
        acceptText: 'Yes',
        cancelText: 'No',
        accept: async () => {
          try {
            const payload = { ...this.form }
            const res = await this.$http.put(`admin/organization-tab/update/${this.form.organization}`, payload)
            const message = (res && res.data && res.data.message) || 'Updated successfully'
            this.$vs.notify({ title: 'Success', text: message, color: 'success', position: 'top-center', time: 3000 })
            this.fetchTabDetails()
          } catch (e) {
            const message = (e && e.message) || 'Failed to update settings'
            this.$vs.notify({ title: 'Error', text: message, color: 'danger', position: 'top-center', time: 4000 })
          }
        }
      })
    }
  },

  
  /** watch */
  watch: {
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-creator',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-creator > .con-vs-loading')
      }
    }
  }
}
</script>
  <style>
  .cropper-image {
    height: 400px;
    background: #ddd;
  }
  </style>
  